import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Button } from '../../globalStyles';
import {
  InfoSec,
  InfoRow,
  InfoColumn,
  TextWrapper,
  TopLine,
  Heading,
  Subtitle,
  ImgWrapper,
  Img
} from './InfoSection.elements';
import { BsDot  } from 'react-icons/bs'
import img1 from'../../images/img1.png';
import img4 from '../../images/img4.png';
import img3 from '../../images/img3.png';

function Products({
  primary,
  lightBg,
  topLine,
  lightTopLine,
  lightText,
  lightTextDesc,
  headline,
  description,
  buttonLabel,
  img,
  bglight,
  alt,
  imgStart,
  start,
  boxsh
}) {
  return (
    <>
      <InfoSec lightBg={true} boxsh={false}>
        <Container>
          <InfoRow imgStart={imgStart}>
          <InfoColumn>
              <ImgWrapper >
                <Img src={img1} alt={alt} />
              </ImgWrapper>
            </InfoColumn>
            <InfoColumn>
              <TextWrapper>
                <Heading lightText={true}>We provide Elevators for all buildings.</Heading>
                <TopLine style={{ color:'#fff'}} lightTopLine={lightTopLine} bglight={  bglight}
>Product Highlights:</TopLine>
                <Subtitle lightTextDesc={true}> <BsDot  style={{ fontSize:"15px" }} />Machine room and machine roomless designs.         <br /> <BsDot  style={{ fontSize:"15px" }} />We offer high speed solutions.-Industry leading after sales service, maintenance plans are applied according the type of your building.<br/><BsDot  style={{ fontSize:"15px" }} />We utilize dual core, high performance, micro controllers to ensure maximum safety and performance. Destination control systems are also an option with our elevators.                  <br /> <BsDot  style={{ fontSize:"15px" }} />  Our elevator consume less electricity,  our innovative machines and drive controller, Moreover, use of L.E.D lighting across all of our cabins further saves your electricity bills..</Subtitle>
              </TextWrapper>
            </InfoColumn>
          </InfoRow>
          <br />
                    <br/>

          <InfoRow style={{ flexDirection:'row-reverse'}} >
          <InfoColumn>
              <ImgWrapper>
                <Img src={img4} alt={alt} />
              </ImgWrapper>
            </InfoColumn>
            <InfoColumn>
              <TextWrapper>
                <Heading lightText={true}>Escalators & Moving walks for commercial, administrative, and heavy traffic buildings</Heading>
                 <TopLine lightTopLine={lightTopLine} bglight={  bglight} style={{ color:'#fff'}}
>Product Highlights:</TopLine>
                <Subtitle lightTextDesc={true}><BsDot  style={{ fontSize:"15px" }} /> We provide indoor & outdoor Escalators and Moving Walks. <br /> <BsDot  style={{ fontSize:"15px" }} /> Safe and Reliable Solutions. <br /> <BsDot  style={{ fontSize:"15px" }} /> Industry leading after sales service, maintenance plans are applied according the type of your building. <br /> <BsDot  style={{ fontSize:"15px" }} /> Also, we provide inclined & horizontal products.</Subtitle>
              </TextWrapper>
            </InfoColumn>
          </InfoRow>
          <br/>
         
                    <br/>

          <InfoRow imgStart={imgStart}>
          <InfoColumn>
              <ImgWrapper  >
                <Img src={img3} alt={alt} />
              </ImgWrapper>
            </InfoColumn>
            <InfoColumn>
              <TextWrapper>
                <Heading lightText={true}>Our maintenance plan ensures maximum service life plus maximum comfort for our customers.</Heading>
                 <TopLine  style={{ color:'#fff'}} lightTopLine={lightTopLine} bglight={  bglight}
>Product Highlights:</TopLine>
                <Subtitle lightTextDesc={true}>  <BsDot  style={{ fontSize:"15px" }} />We provide indoor & outdoor Escalators and Moving Walks. <br/> <BsDot  style={{ fontSize:"15px" }} />Safe and Reliable Solutions.<br/> <BsDot  style={{ fontSize:"15px" }} />Industry leading after sales service, maintenance plans are applied according the type of your building. <br/> <BsDot  style={{ fontSize:"15px" }} />Also, we provide inclined & horizontal products.'</Subtitle>
              </TextWrapper>
            </InfoColumn>
          </InfoRow>
        </Container>
      </InfoSec>
    </>
  );
}

export default Products;
